/**
 * AddURLPolicyCtrl controller
 *
 */
import { addRule } from './urlRule.directive'

/**
 * AddURLPolicyCtrl controller
 *
 * @class AddURLPolicyCtrl
 * @memberof mwApp/streams
 * @see mwApp/streams
 *
 * @ngdoc controller
 * @name mwApp/streams.controller:AddURLPolicyCtrl
 */

/* @ngInject */
export default function AddURLPolicyCtrl ($scope, $location, $state, authSvc, UrlPolicy, urlPolicy, extra) {
  const vm = this
  vm.exrtra = extra
  vm.urlPolicy = urlPolicy
  // vm.defaultPolicy = defaultPolicy
  // vm.urlPolicy.defaultStreamPolicy = vm.urlPolicy.id === vm.defaultPolicy.id
  vm.isNew = urlPolicy._isNew()
  vm.canCreate = authSvc.hasAccess('createUrlPolicy')
  vm.canEdit = authSvc.hasAccess('editUrlPolicy')
  vm.canView = authSvc.hasAccess('viewUrlPolicy')
  vm.canDelete = authSvc.hasAccess('deleteUrlPolicy')

  if (vm.isNew && !vm.canCreate) {
    $state.go('app.404')
    return
  }

  if (!vm.isNew && !(vm.canView || vm.canCreate || vm.canEdit || vm.canDelete)) {
    $state.go('app.404')
    return
  }

  vm.isView = !!$location.search().view || (!vm.isNew && !vm.canEdit)

  vm.addRule = addRule

  vm.save = function (form) {
    if (form.$invalid) {
      return
    }
    vm.setDisable();

    (function convertRules (root, rules) {
      rules.reduce((root, rule, index, arr) => {
        if (rule.$subRules.length) {
          rule.then = {}
          convertRules(rule.then, rule.$subRules)
        } else {
          rule.then = null
        }

        Object.assign(root, rule)
        if (index + 1 < arr.length) {
          root.otherwise = {}
        } else {
          root.otherwise = null
        }
        return root.otherwise
      }, root)
    })(vm.urlPolicy.rule, vm.urlPolicy.$rules)

    urlPolicy._save()
      .then(vm.location(urlPolicy).reload)
      .finally(vm.unsetDisable)
  }

  $scope.$on('$viewContentLoaded', function () {
    vm.location.setGoBackLink('streams/url-policies')
  })
}
